import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthProviderLocationPreview,
	GetHealthProviderLocationPreviewModel,
	GetHealthProviderLocationPreviewParams,
} from 'domain/usecases/private/booking-flow/health/get-health-provider-location-preview';

export class RemoteGetHealthProviderLocationPreview implements GetHealthProviderLocationPreview {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthProviderLocationPreviewModel>,
	) {}

	async get({
		signal,
		...params
	}: GetHealthProviderLocationPreviewParams): Promise<GetHealthProviderLocationPreviewModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
